export enum ngxPrintMarkerPosition {
    Topleft,
    TopRight,
    BottomLeft,
    BottomRight
}
